import React from "react";
import { Link } from "gatsby";

const Button = ({ style }) => (
  <Link className="button is-primary is-large has-text-weight-bold" to="/signup" style={style}>
    Start Dripping
  </Link>
);

export default Button;
